import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { openPopup } from '../apps/Utils';

const Introduction = () => {
    const manualLink = '/tools/analog-inspection-tool/#/manual';
    const wordConversionToolLink = '/tools/analog-inspection-tool/files/ConvertingIchitaro2Word.xlsm';

    return (
        <div className='step-accordion'>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <h3>はじめに</h3>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='introduction-message'>
                        <h4>初めてツールをご利用される方へ</h4>
                        <ul>
                            <li>
                                ツールの操作方法は<a href={manualLink} onClick={(e) => { e.preventDefault(); openPopup(manualLink); }}>マニュアル</a>
                                を参照してください。
                            </li>
                            <li>本ツールは予告なくURLが変更されたり削除される場合があります。</li>
                        </ul>
                        <h4>本ツールはdocx形式のWordのみサポートしています。</h4>
                        <ul>
                            <li>doc形式をご利用の場合、手動でdocx形式に保存してからご利用ください。</li>
                            <li>一太郎（jtd形式）をご利用の場合、<a href={wordConversionToolLink}>一太郎→Word変換ツール</a>をご利用ください。</li>
                        </ul>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default Introduction;
